export { HEAD_CELLS } from './headCell';
export { TRIGGERS } from './triggers';
export { HISTORY_HEAD_CELLS } from './historyHeadCell';

export const ENTITY = [
  {
    value: 'all',
    label: 'Всем'
  },
  {
    value: 'amount',
    label: 'Количество'
  },
  {
    value: 'files',
    label: 'Загрузить файл'
  }
];

export const TYPE_EVENTS = [
  {
    value: 'bonus',
    label: 'Бонус'
  },
  {
    value: 'promokod',
    label: 'Промокод'
  }
];

export const NUMBERS_PARTICANTS = [
  {
    value: 'no_limit',
    label: 'Без ограничения'
  },
  {
    value: 'enter_value',
    label: 'Ввести количество'
  }
];

export const TYPE_COMPANY = [
  {
    value: 'no_limit',
    label: 'Целевая'
  },
  {
    value: 'enter_value',
    label: 'Бесцелевая'
  },
  {
    value: 'no_limit_asd',
    label: 'Персональная'
  },
  {
    value: 'enter_value_AAFEW',
    label: 'Партнерская'
  }
];

export const REGULAR_EXPRESSIONS = {
  modal_and_service: /^[0-9A-Za-zА-Яа-я" \-_@]+$/,
  email_validation_pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
}
